import { Box, Grid, Typography } from '@mui/material'
import { WrapperProps } from '../../../components'
import { MemberMessage } from '../../../utils/classes/graphql'

interface MemberMessageTabContentWrapperProps extends WrapperProps {
  message: MemberMessage
}

export const MemberMessageTabContentWrapper = ({
  children,
  message
}: MemberMessageTabContentWrapperProps) => {
  const { lahetysPvm, viestinNimi } = message

  return (
    <Grid container spacing={2}>
      <Grid item md={7} xs={7}>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '16px'
          }}
        >
          {viestinNimi}
        </Typography>
      </Grid>
      <Grid item md={5} xs={5}>
        <Box sx={{ textAlign: 'right', color: '#707070', fontSize: '16px' }}>
          {lahetysPvm}
        </Box>
      </Grid>
      <Grid container item>
        {children}
      </Grid>
    </Grid>
  )
}
